import Logo from "../ui/Logo"

export default function LogoLoader({ message = "Loading..." }) {

    return (

        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white ">

            <div className="flex flex-col items-center gap-2  bg-white rounded-xl shadow-2xl shadoe-black w-3xs h-3xs">

                {/* Logo container */}

                    <Logo className="" />
                    {/* Loader row */}
                    <div className="flex items-center gap-2">

                        {/* animated dots */}
                        <div className="flex gap-2">

                            <span className="size-3 rounded-full bg-pink-500 animate-bounce"></span>

                            <span className="size-3 rounded-full bg-pink-600 animate-bounce [animation-delay:0.2s]"></span>

                            <span className="size-3 rounded-full bg-pink-700 animate-bounce [animation-delay:0.4s]"></span>

                        </div>

                        {/* message */}
                        <p className="text-gray-500 font-medium tracking-wide">
                            {message}
                        </p>

                    </div>




            </div>

        </div>

    )

}